import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { store } from './store';
import { ThemeContextProvider } from './contexts/ThemeContext';
import { TailwindThemeProvider } from './contexts/TailwindThemeContext';
import { PaymentNotificationProvider } from './contexts/PaymentNotificationContext';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes/AppRoutes';
import { pwaNotificationService } from './services/pwaNotificationService';

// Configurar React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
});

// Deploy Dudu - Atualização da logo

function App() {
  useEffect(() => {
    // Inicializar PWA e notificações
    const initializePWA = async () => {
      try {
        console.log('🚀 Inicializando PWA...');
        
        // Inicializar serviço de notificações
        const success = await pwaNotificationService.initialize();
        
        if (success) {
          console.log('✅ PWA inicializado com sucesso');
          
          // Detectar quando pode ser instalado
          pwaNotificationService.onCanInstall((event) => {
            console.log('📱 App pode ser instalado!', event);
            // Aqui você pode mostrar um banner de instalação
          });
          
          // Detectar quando foi instalado
          pwaNotificationService.onInstalled(() => {
            console.log('🎉 App foi instalado!');
            // Aqui você pode enviar analytics ou mostrar uma mensagem
          });
          
          // Log do status de instalação
          const isInstalled = pwaNotificationService.isInstalled();
          console.log('📱 Status da instalação:', isInstalled ? 'Instalado' : 'Não instalado');
        }
      } catch (error) {
        console.error('❌ Erro ao inicializar PWA:', error);
      }
    };
    
    initializePWA();
    
    // Cleanup ao desmontar
    return () => {
      pwaNotificationService.cleanup();
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <TailwindThemeProvider>
          <ThemeContextProvider>
            <PaymentNotificationProvider>
              <Router>
                <AuthProvider>
                  <div style={{
                    width: '100%',
                    maxWidth: '100%',
                    overflowX: 'hidden',
                    minHeight: '100vh',
                    position: 'relative'
                  }}>
                    <AppRoutes />
                  </div>
                </AuthProvider>
              </Router>
            </PaymentNotificationProvider>
          </ThemeContextProvider>
        </TailwindThemeProvider>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
